<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div
      id="edituser"
      class="modal fade"
      :class="{ show: show }"
      style="background: rgba(0,0,0,0.5)"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" v-click-outside="onCancel" id="modal">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5 class="px-2 mb-0">
                {{ $t("edit_contact") }}
              </h5>
              <p class="cursor-pointer px-2" @click="onCancel">
                <img src="../../assets/images/Vector (1).png" alt="" />
              </p>
            </div>
            <div
              v-if="mssg"
              align="center"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              align="center"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>
            <form class="p-2" @submit.prevent="addcontact">
              <div class="form-group">
                <label for="fullname"> {{ $t("full_name") }} </label>
                <input
                  type="text"
                  name="name"
                  v-model="fullname"
                  class="form-control"
                  required
                  id="receiver-name"
                  placeholder="Enter Receiver Name "
                />
                <div
                  v-show="selectNotification !== ''"
                  class="alert-danger alert-dismissible fade show"
                >
                  <p>{{ selectNotification }}</p>
                </div>
              </div>

              <div class="form-group">
                <label for="InputNumber"> {{ $t("phone") }} </label>
                <div class="form-group">
                  <input
                    class="form-control"
                    type="tel"
                    id="phone_number"
                    v-model="number"
                  />
                </div>
                <p v-if="ErrorPhone" class="my-0 small text-error p-1">
                  {{ ErrorPhone }}
                </p>
              </div>
              <div class="form-group">
                <label for="fullname"> {{ $t("email") }} </label>
                <input
                  v-model="email"
                  type="text"
                  name="name"
                  class="form-control"
                  disabled="disabled"
                  required
                  id="email"
                  placeholder="Enter Email Address"
                />
              </div>
              <div class="form-group">
                <label for="fullname"> Address </label>
                <input
                  v-model="address"
                  type="text"
                  name="name"
                  class="form-control"
                  required
                  id="address"
                  placeholder="Enter Address"
                />
              </div>
              <div style="display:flex; justify-content: end">
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="selectNotification !== ''"
                >
                  {{ $t("edit_contact") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import * as intlTelInput from "../../assets/js/intlTelInput";
import * as utils from "../../assets/js/utils";

export default {
  name: "EditContact",
  props: {
    show: Boolean,
    contact: Array,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      fullname: "",
      email: "",
      number: "",
      address: "",
      mssg: "",
      ErrorPhone: "",
      Errormssg: "",
      iti: "",
      selectNotification: "",
    };
  },
  components: {
    Loading,
  },
  mounted() {
    this.initialiseForm();
  },
  watch: {
    contact: {
      handler: function() {
        console.log("watch ");
        this.initialiseForm();
      },
      deep: true,
    },
    fullname: {
      handler() {
        if (/^[a-zA-Z\s]*$/.test(this.fullname))
          return (this.selectNotification = "");
        else this.selectNotification = this.$t("must_contain");
      },
    },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters([]),
  },
  methods: {
    ...mapActions(["editContact", "getContacts"]),
    onCancel() {
      this.$emit("closeEditContactModal");
    },
    initialiseForm() {
      setTimeout(() => {
        this.fullname = this.contact[0].name;
        var input = document.querySelector("#phone_number");
        this.iti = intlTelInput(input, {
          separateDialCode: true,
          utilsScript: utils,
        });
        var number = "+" + this.contact[0].phoneNumber.toString();
        this.iti.setNumber(number);
        // console.log(this.iti.isValidNumber(), "number validation");
        // console.log(this.iti, "checking iti presence");
        // if (!this.iti.isValidNumber()) {
        //   number =
        //     "+" +
        //     this.contact[0].countryCode.toString() +
        //     this.contact[0].phoneNumber.toString();
        //   // console.log((number))
        //   // console.log(number, "iti setting number country code")
        //   this.iti.setNumber(number);
        // }
        this.number = this.contact[0].phoneNumber;
        this.email = this.contact[0].email;
        this.address = this.contact[0].address;
      }, 200);
    },
    addcontact() {
      let number = this.iti.getNumber().slice(1);
      this.ErrorPhone = "";
      if (!this.iti.isValidNumber()) {
        this.ErrorPhone = this.$t("valid_phone");
      } else {
        this.isLoading = true;
        this.Errormssg = "";
        const newContact = {
          phoneNumber: `${parseInt(number)}`,
          name: this.fullname,
          address: this.address,
          email: this.email,
        };
        this.editContact({ newContact, id: this.contact[0].id })
          .then((res) => {
            this.getContacts().then(() => {
              this.onCancel();
            });
            this.$emit("showSuccessPopup", {
              msg: this.$t("edit_msg_contact"),
              heading: this.$t("edit_heading_contact"),
            });
            this.isLoading = false;
            this.mssg =
              res.data.message[0].toUpperCase() + res.data.message.slice(1);
          })
          .catch((error) => {
            this.isLoading = false;
            this.Errormssg =
              error.response.data.message[0].toUpperCase() +
              error.response.data.message.slice(1);
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      }
    },
  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 500px !important;
}
</style>

<i18n>
  {
      "en": {
          "add_user": "Add a User",
          "all_users": "All Users",
          "edit_contact": "Edit Contact",
          "email": "Email Address",
          "full_name": "Receiver's Name",
          "man_user_right": "Manage user rights for members of your business",
          "manage": "Manager",
          "must_contain": "Must conain only Letters",
          "name": "Name",
          "phone": "Phone Number",
          "staff": "Staff",
          "user_rights": "User Rights",
          "valid_phone": "This phone number is not valid"
      },
      "fr": {
          "add_user": "Ajouter un utilisateur",
          "all_users": "Tous les utilisateurs",
          "edit_user": "Modifier l'utilisateur",
          "email": "E-mail",
          "full_name": "Nom et prénom",
          "man_user_right": "Gérez les droits d'utilisation des membres de votre entreprise",
          "manage": "Directeur",
          "must_contain": "Ne doit contenir que des lettres",
          "name": "Nom",
          "phone": "Numéro de téléphone",
          "staff": "Personnel",
          "user_rights": "Droits de l'utilisateur",
          "valid_phone": "Ce numéro de téléphone n'est pas valide"
      },
      "sw": {
          "add_user": "ONGEZA MTUMIAJI",
          "all_users": "Watumiaji Wote",
          "edit_user": "Badilisha mtumiaji",
          "email": "Barua pepe",
          "full_name": "Jina kamili",
          "man_user_right": "Dhibiti haki za mtumiaji za wanachama wa biashara yako",
          "manage": "Meneja",
          "must_contain": "Lazima iwe na Barua tu",
          "name": "Jina",
          "phone": "Nambari ya simu",
          "staff": "STAFF",
          "user_rights": "Haki za Mtumiaji",
          "valid_phone": "Nambari hii ya simu si sahihi"
      }
  }
  </i18n>
